import React, {Component} from 'react'
import {keyBy, forEach, values, trim, take} from 'lodash'

import {LocationSearchTab} from '../../../modules/locations/audit/LocationSearchTab'


const mapPlaceRowsToLocations = (account, category, keywords, rows) => {
  return rows.map(row => {
    return {
      placeId: row.placeId,
      accountId: account.id,
      busName: row.busName,
      resellerLocationId: row.resellerLocationId,
      primaryKeyword: category,
      website: row.website,
      alternateWebsites: row.alternateWebsites,
      email: row.email,
      alternateEmails: [],
      address: {
        street: row.street,
        suite: row.suite,
        city: row.city,
        postalCode: row.postalCode,
        state: row.state,
        country: row.country
      },
      primaryPhone: row.phone,
      alternatePhoneNumbers: row.alternatePhoneNumbers,
      auditOnly: true,
      customListings: [],
      brandMonitoring: {
        listingMonitoring: [{
          name: ''
        }],
        socialMonitoring: []
      },
      rankingKeywords: keywords.map(x => ({keyword: x}))
    }
  })

}

class SearchLocationsContainer extends Component {

  constructor(props) {
    super(props)
    this.locationService = props.locationService
    this.locationsManagerService = props.locationsManagerService
    this.state = {
      accounts: props.accounts,
      categories: props.categories,
      locations: {},
    }
    this.success = this.success.bind(this)
    this.failure = this.failure.bind(this)
    this.clearAlert = this.clearAlert.bind(this)
    this.onAccountSelect = this.onAccountSelect.bind(this)
    this.onAccountSelect(this.state.accounts[0])
  }

  onAccountSelect(account) {
    if (account && !this.state.locations.hasOwnProperty(account.id)) {
      const accountId = account.id
      this.locationService.locationsForAccount(accountId).then(locations => {
        this.setState(
          {
            locations: {
              ...this.state.locations,
              [accountId]: keyBy(locations, 'placeId')
            }
          }
        )
      })
    }

    // we would need to load in the locations and store them into the map
    // we would then set the state of the locations prop which will pass to the child
    // components.

  }

  handleCreateLocations(account, category, keywords, rows, onCompleted) {
    const locationsToCreate = mapPlaceRowsToLocations(account, category, keywords, rows)
    const promises = forEach(locationsToCreate, loc => new Promise(resolve => {
      this.locationsManagerService.addLocation(loc)
        .then(res => {
          onCompleted(res)
          resolve(res)
        })
    }))

    return Promise.all(promises)
  }

  success(message, title = "Success") {
    this.refs.container.success(message, title, {
      closeButton: true,
      showAnimation: 'animated pulse',
      hideAnimation: null,
    })
  }

  failure(message, title = "Failure") {
    this.refs.container.error(message, title, {
      closeButton: true,
      showAnimation: 'animated pulse',
      hideAnimation: null,
    })
  }

  clearAlert() {
    this.refs.container.clear();
  }

  render() {
    return (
      <div>

        <LocationSearchTab
          accounts={this.state.accounts}
          categories={this.state.categories}
          locations={this.state.locations}
          toast={{
            success: this.success,
            failure: this.failure,
            clear: this.clearAlert,
          }}
          editorData={this.props.editorData}
          onAccountSelect={this.onAccountSelect}
          onCreateLocationsSubmitted={this.handleCreateLocations.bind(this)}
        />
      </div>
    )
  }
}

export default SearchLocationsContainer
